<template>
  <div class="accordion" :class="{ 'accordion_filled': isFilled }">
    <div class="accordion__header" :class="{ 'accordion__header--filled': isFilled }"  @click="toggle">
      <div class="accordion__header-content">
        <h3 class="accordion__title" :class="{ 'accordion__title--filled': isFilled }">{{ $t(title) }} {{ titleNumber }}</h3>
        <p v-if="subtitle" class="accordion__subtitle" :class="{ 'accordion__subtitle--filled': isFilled }" v-html="$t(subtitle)"></p>
      </div>
      <button class="accordion__toggle" :class="{ 'accordion__toggle--open': computedIsOpen, 'accordion__toggle--filled': isFilled }" type="button">
        <span v-if="computedIsOpen" class="accordion__icon accordion__icon--close">
            <img src="@/assets/images/icon-exit.svg" alt="exit" />
        </span>
        <span v-else class="accordion__icon accordion__icon--arrow">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.03457 -3.67176e-07L9.03457 16.8M9.03457 16.8L0.634571 8.44544M9.03457 16.8L17.4346 8.44544" stroke="white" stroke-width="1.8" />
</svg>
        </span>
      </button>
    </div>
    <transition name="accordion">
      <div v-show="computedIsOpen" class="accordion__content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "UiAccordion",
  props: {
    title: {
      type: String,
      required: true,
    },
    titleNumber: {
      type: Number | String,
      default: 0,
    },
    subtitle: {
      type: String,
      default: "",
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      internalIsOpen: this.defaultOpen,
    };
  },
  computed: {
    computedIsOpen() {
      // Если проп isOpen передан, используем его (управляемый режим)
      // Иначе используем внутреннее состояние (неуправляемый режим)
      return this.isOpen !== undefined ? this.isOpen : this.internalIsOpen;
    },
  },
  methods: {
    toggle() {
      if (this.isOpen !== undefined) {
        // Управляемый режим - эмитим событие, родитель управляет состоянием
        this.$emit("toggle", !this.isOpen);
      } else {
        // Неуправляемый режим - управляем сами
        this.internalIsOpen = !this.internalIsOpen;
        this.$emit("toggle", this.internalIsOpen);
      }
    },
  },
};
</script>

<style scoped>
.accordion {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.03);
background: #fff;
border-radius: 10px;

}

.accordion.accordion_filled {
  background: linear-gradient(45deg, #00afbc 0%, #007f9f 100%);
}

.accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.accordion__header-content {
  flex: 1;
  color: #333;
}

.accordion.accordion_filled .accordion__title {
  color: #fff;
}

.accordion.accordion_filled .accordion__subtitle {
  color: #fff;
}

.accordion.accordion_filled .accordion__toggle {
  background: #fff;
  color: #007f9f;
}

.accordion.accordion_filled .accordion__toggle:hover {
  background: #f6f6f6;
}

.accordion.accordion_filled .accordion__toggle--open {
  background: #fff;
}

.accordion.accordion_filled .accordion__toggle--open:hover {
  background: #006a8a;
}

.accordion.accordion_filled .accordion__icon--close {
  color: #fff;
}

.accordion.accordion_filled .accordion__icon--arrow svg path {
  stroke: #007f9f;
}

.accordion.accordion_filled .accordion__content {
  background: #c1dee5;
  color: #111;
}

.accordion.accordion_filled .accordion__content {
  color: #333;
}

/* Filled modifiers applied directly via classes (reactive to isFilled) */
.accordion__header--filled .accordion__title {
  color: #fff;
}

.accordion__header--filled .accordion__subtitle {
  color: #fff;
}

.accordion__toggle--filled {
  background: #fff;
  color: #007f9f;
}

.accordion__toggle--filled:hover {
  background: #f6f6f6;
}

.accordion__title {
  font-family: "Eurostile Extd", sans-serif;
  font-weight: 900;
font-size: 18px;
line-height: 100%;
  color: #007f9f;
  margin: 0 0 8px 0;
}

.accordion__subtitle {
  font-family: "Eurostile Extd", sans-serif;
  font-weight: 500;
font-size: 15px;
line-height: 100%;
color: #111;
  margin: 0;
}

.accordion__toggle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background-color: #007f9f;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 20px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  padding: 0;
}

.accordion__toggle:hover {
  background-color: #006a8a;
  transform: scale(1.05);
}

.accordion__toggle--open {
  background-color: #b3e5d1;
  color: #007f9f;
}

.accordion__toggle--open:hover {
  background-color: #9dd4b8;
}

.accordion__icon {
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  display: block;
}

.accordion__icon--close {
  font-size: 24px;
}

.accordion__icon--arrow {
  font-size: 18px;
}

.accordion__content {
  padding: 20px 0;
 
  overflow: hidden;
}

/* Анимация раскрытия/сворачивания */
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.accordion-enter-to,
.accordion-leave {
  max-height: 1000px;
  opacity: 1;
}
</style>
